import React, { useEffect, useState } from 'react';
import { buildCriterionExpression } from '@coveo/headless';

export const Sort = props => {
  const { controller } = props;
  const [state, setState] = useState(controller.state);

  useEffect(() => controller.subscribe(() => setState(controller.state)), []);

  const getCriterionFromName = name =>
    props.criteria.find(([criterionName]) => criterionName === name);

  const getCurrentCriterion = () =>
    props.criteria.find(
      ([, criterion]) =>
        state.sortCriteria === buildCriterionExpression(criterion)
    );

  return (
    <select
      value={getCurrentCriterion()[0]}
      onChange={e => controller.sortBy(getCriterionFromName(e.target.value)[1])}
    >
      {props.criteria.map(([criterionName], index) => (
        <option key={index} value={criterionName}>
          {criterionName}
        </option>
      ))}
    </select>
  );
};
